export const widgetDefaults = {
  pageName: 'booking_calendar_widget',
};

export enum CalendarErrors {
  SELECTED_SLOT_VALIDATION_NO_SELECTED_LOCATION = 'SELECTED_SLOT_VALIDATION_NO_SELECTED_LOCATION',
  SELECTED_SLOT_VALIDATION_NO_SELECTED_DURATION = 'SELECTED_SLOT_VALIDATION_NO_SELECTED_DURATION',
  SELECTED_SLOT_VALIDATION_NO_SELECTED_STAFF_MEMBER = 'SELECTED_SLOT_VALIDATION_NO_SELECTED_STAFF_MEMBER',
  SELECTED_SLOT_VALIDATION_NO_TIME_SELECTED_ERROR = 'SELECTED_SLOT_VALIDATION_NO_TIME_SELECTED_ERROR',
  RESCHEDULE_SERVER_ERROR = 'RESCHEDULE_SERVER_ERROR',
}

export enum SetError {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

export enum Preference {
  LOCATION = 'location',
  DURATION = 'duration',
  STAFF_MEMBER = 'staffMember',
}

export enum ErrorMessages {
  NO_SERVICE_AVAILABILITY = 'NO_SERVICE_AVAILABILITY',
}

export enum WidgetComponents {
  TIME_PICKER = 'TIME_PICKER',
  DATE_PICKER = 'DATE_PICKER',
  BOOKING_DETAILS = 'BOOKING_DETAILS',
  TIMEZONE_PICKER = 'TIMEZONE_PICKER',
  RESCHEDULE_DIALOG = 'RESCHEDULE_DIALOG',
  JOIN_WAITLIST_DIALOG = 'JOIN_WAITLIST_DIALOG',
  FILTER = 'FILTER',
}

export enum WidgetElements {
  TIME_SLOT = 'TIME_SLOT',
  MONTH_ARROW = 'MONTH_ARROW',
  DATE_IN_MONTH = 'DATE_IN_MONTH',
  GO_TO_NEXT_AVAILABLE_DATE_LINK = 'GO_TO_NEXT_AVAILABLE_DATE_LINK',
  CONFIRM_BUTTON = 'CONFIRM_BUTTON',
  DROPDOWN = 'DROPDOWN',
  CLOSE_BUTTON = 'CLOSE_BUTTON',
  CHECKBOX = 'CHECKBOX',
  COUNTER = 'COUNTER',
  CHECKBOX_ALL = 'CHECKBOX_ALL',
  FILTER_BUTTON = 'FILTER_BUTTON',
  CLEAR_BUTTON = 'CLEAR_BUTTON',
}

export enum TriggeredByOptions {
  INITIALIZE_WIDGET = 'INITIALIZE_WIDGET',
  TIMEZONE_CHANGED = 'TIMEZONE_CHANGED',
  DATE_SELECTED = 'DATE_SELECTED',
  MONTH_SELECTED = 'MONTH_SELECTED',
  BOOKING_DETAILS_CLEAR_BUTTON = 'BOOKING_DETAILS_CLEAR_BUTTON',
  STAFF_MEMBER_BOOKING_PREFERENCE_SELECTED = 'STAFF_MEMBER_BOOKING_PREFERENCE_SELECTED',
  LOCATION_BOOKING_PREFERENCE_SELECTED = 'LOCATION_BOOKING_PREFERENCE_SELECTED',
  BOOKING_DETAILS_BOOKING_PREFERENCE_SELECTED = 'BOOKING_DETAILS_BOOKING_PREFERENCE_SELECTED',
  GO_TO_NEXT_AVAILABLE_DATE_LINK = 'GO_TO_NEXT_AVAILABLE_DATE_LINK',
  TIME_SELECTED = 'TIME_SELECTED',
  SUBMIT = 'SUBMIT',
  FILTER_CHANGED = 'FILTER_CHANGED',
}

export enum InitializeCalendarDateOptions {
  FIRST_AVAILABLE_DATE = 'FIRST_AVAILABLE_DATE',
  TODAY = 'TODAY',
}

export type TimeSlotsAvailability = {
  AVAILABLE: number;
  FULL: number;
  TOO_LATE_TO_BOOK: number;
  TOO_EARLY_TO_BOOK: number;
  WAITLIST: number;
};

export const BOOKINGS_CALENDAR_REFERRAL_INFO = 'booking_calendar_widget';
